/**
 * 应用配置文件
 * 支持开发、测试、生产环境配置
 */

// 环境检测
const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const isProduction = window.location.hostname === 'atc.chinaflier.com';

// 环境配置
const config = {
  // 开发环境配置
  development: {
    apiBaseUrl: 'http://localhost:3000',
    websocketUrl: 'ws://localhost:3000',
    environment: 'development',
    debug: true
  },
  
  // 测试环境配置
  testing: {
    apiBaseUrl: 'https://test.atc.chinaflier.com',
    websocketUrl: 'wss://test.atc.chinaflier.com',
    environment: 'testing',
    debug: true
  },
  
  // 生产环境配置
  production: {
    apiBaseUrl: 'https://atc.chinaflier.com',
    websocketUrl: 'wss://atc.chinaflier.com',
    environment: 'production',
    debug: false
  }
};

// 根据当前环境选择配置
let currentConfig;

// 检查是否有保存的环境设置
const savedEnvironment = localStorage.getItem('app_environment');

if (savedEnvironment && config[savedEnvironment]) {
  currentConfig = config[savedEnvironment];
  console.log(`🔄 使用保存的环境配置: ${savedEnvironment}`);
} else if (isDevelopment) {
  currentConfig = config.development;
  console.log('🔧 使用开发环境配置');
} else if (isProduction) {
  currentConfig = config.production;
  console.log('🚀 使用生产环境配置');
} else {
  // 默认使用测试环境配置
  currentConfig = config.testing;
  console.log('🧪 使用测试环境配置');
}

// 导出配置
export default {
  // 当前环境配置
  ...currentConfig,
  
  // 所有环境配置（用于调试）
  all: config,
  
  // 环境检测函数
  isDevelopment,
  isProduction,
  
  // 获取当前环境名称
  getEnvironment() {
    return currentConfig.environment;
  },
  
  // 获取API基础URL
  getApiBaseUrl() {
    return currentConfig.apiBaseUrl;
  },
  
  // 获取WebSocket URL
  getWebSocketUrl() {
    return currentConfig.websocketUrl;
  },
  
  // 是否开启调试模式
  isDebugEnabled() {
    return currentConfig.debug;
  },
  
  // 打印当前配置（调试用）
  printConfig() {
    if (this.isDebugEnabled()) {
      console.log('📋 当前应用配置:', {
        environment: this.getEnvironment(),
        apiBaseUrl: this.getApiBaseUrl(),
        websocketUrl: this.getWebSocketUrl(),
        debug: this.isDebugEnabled()
      });
    }
  }
}; 